<template>
    <page-content
        :loading="isLoading"
        :error="error"
    >
        <template
            v-slot:error
        >
            <v-container>
                <v-row>
                    <v-col
                        cols="12"
                        sm="6"
                    >
                        <v-img
                            class="my-5"
                            :src="require('../../assets/emails.svg')"
                        />
                    </v-col>
                    <v-col
                        class="text-center text-sm-left"
                        cols="12"
                        sm="6"
                    >
                        <div class="d-flex flex-column fill-height justify-center">
                            <h1>{{ errorTitle }}</h1>
                            <p class="body-1">
                                {{ errorMessage }}
                            </p>
                            <div>
                                <v-btn
                                    color="primary"
                                    class="mr-3"
                                    :to="{ name: 'login' }"
                                >
                                    Login
                                </v-btn>
                                <v-btn
                                    v-if="showContactButton"
                                    color="primary"
                                    outlined
                                    :to="{ name: 'contactUs' }"
                                >
                                    Contact Us
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </page-content>
</template>

<script>
import axios from 'axios'
import jwtDecode from 'jwt-decode'

import MessageBus from '../../utils/buses/MessageBus'
import UserBus from '../../utils/buses/UserBus'

class ExpiredTokenError extends Error {}

class VerifyEmailApiError extends Error {}

export default {
    data () {
        return {
            isLoading: true,
            error: null,
            errorTitle: null,
            showContactButton: false
        }
    },

    async mounted () {
        const token = this.$route.params.token

        // verify token
        try {
            const decoded = jwtDecode(token)

            // check token expiration
            const expire = decoded.exp
            const now = (new Date().getTime() / 1000)
            if (now > expire) {
                throw new ExpiredTokenError('Token has expired')
            }

            const res = await axios.put('/auth/verify', { token })
                .catch(err => {
                    console.error('Verify Email API Error', err)
                    throw new VerifyEmailApiError('api error')
                })

            // update token so routing works properly
            const newToken = res.data.token
            UserBus.setToken(newToken)

            MessageBus.sendMessage('Email verified!', 'success')
            this.$router.push({ name: 'chooseHandle' })
        } catch (err) {
            const DEFAULT_ERROR_TITLE = 'There was a problem'
            const DEFAULT_ERROR_MESSAGE = 'Woops. There was an error validating your email. Please log in and send another email verification. If the problem persists, please contact support.'

            console.error('Error verifying email', err)
            if (err instanceof jwtDecode.InvalidTokenError) {
                // invalid token
                this.errorTitle = 'Token is invalid'
                this.errorMessage = 'Uh oh, your token is invalid! No worries. You can log in and send another email verification.'
            } else if (err instanceof ExpiredTokenError) {
                // expired token
                this.errorTitle = 'Token has expired'
                this.errorMessage = 'Uh oh, your token has expired! No worries. You can log in and send another email verification.'
            } else if (err instanceof VerifyEmailApiError) {
                // api error
                this.errorTitle = DEFAULT_ERROR_TITLE
                this.errorMessage = DEFAULT_ERROR_MESSAGE
                this.showContactButton = true
            } else {
                // default error
                this.errorTitle = DEFAULT_ERROR_TITLE
                this.errorMessage = DEFAULT_ERROR_MESSAGE
                this.showContactButton = true
            }

            // set error. This value is just used to trigger the page-content component to show the error
            // so any truthy value will do.
            // the actual error messages are defined in the template
            this.error = 'error'
        } finally {
            this.isLoading = false
        }
    }
}
</script>
